import { AnalyticsButtonLabels, trackButtonClick } from '@atlassian/temp-analytics';
import { getMicrosEnv } from '@atlassian/temp-shared/environment';
import { NavigationGroup, NavigationItem, NavigationLink } from '@css-xp/graphtypes';
import { helpLegalLinks } from '@css-xp/ppc-consent-hub';
import { getIdentityUrl } from '@css-xp/ppc-utils';
import {
  ATLASSIAN_START_STG_URL,
  ATLASSIAN_START_URL,
  CREDIT_REQUEST_UI_URL,
  CREDIT_REQUEST_UI_STG_URL,
  RESOURCE_HUB_URL,
  PARTNER_MANAGED_SUBSCRIPTIONS_STG_URL,
  PARTNER_MANAGED_SUBSCRIPTIONS_URL,
  PARTNER_PORTAL_URL,
  PARTNER_SUPPORT_STG_URL,
  PARTNER_SUPPORT_URL,
  GSAC_BASE_URL,
  GSAC_BASE_STG_URL,
} from '../constant';
import { getPartnerServiceDeskUrlForGenericHelp } from './partner-service-desk-utils';

enum ENV {
  PRODUCTION = 'production',
}

export const getAtlassianStartUrl = () => {
  switch (getMicrosEnv()) {
    case 'stg-east':
      return ATLASSIAN_START_STG_URL;
    case 'prod-east':
      return ATLASSIAN_START_URL;
    default:
      return ATLASSIAN_START_STG_URL;
  }
};

export const getPartnerSupportUrl = () => {
  switch (getMicrosEnv()) {
    case 'stg-east':
      return PARTNER_SUPPORT_STG_URL;
    case 'prod-east':
      return PARTNER_SUPPORT_URL;
    default:
      return PARTNER_SUPPORT_STG_URL;
  }
};

export const getPartnerSubscriptionsUrl = () => {
  switch (getMicrosEnv()) {
    case 'prod-east':
      return PARTNER_MANAGED_SUBSCRIPTIONS_URL;
    default:
      return PARTNER_MANAGED_SUBSCRIPTIONS_STG_URL;
  }
};

export const getPartnerPortalUrl = () => {
  return PARTNER_PORTAL_URL;
};

export const getResourceHubUrl = () => {
  return RESOURCE_HUB_URL;
};

export const isNavigationLink = (item: NavigationItem): item is NavigationLink => {
  return (item as NavigationLink).url !== undefined;
};

export const isNavigationGroup = (item: NavigationItem): item is NavigationGroup => {
  return (item as NavigationGroup).links !== undefined;
};

export const handleSupportLinkClick = () => {
  window.open(getPartnerServiceDeskUrlForGenericHelp(), '_blank');
  trackPartnerServiceDeskClick();
};

export const handleResourceHubLinkClick = () => {
  window.open(getResourceHubUrl(), '_blank');
};

export const handlePPCTermsOfUseClick = () => {
  window.open(helpLegalLinks.termsOfUseUrl, '_blank');
};

export const handlePPCPrivacyPolicyClick = () => {
  window.open(helpLegalLinks.privacyPolicyUrl, '_blank');
};

export const trackPartnerServiceDeskClick = () => {
  return trackButtonClick(AnalyticsButtonLabels.PARTNER_SERVICE_DESK);
};

export const getCreditUsageUiUrl = (transactionId: string) => {
  switch (getMicrosEnv()) {
    case 'prod-east':
      return `${CREDIT_REQUEST_UI_URL}/${transactionId}`;
    default:
      return `${CREDIT_REQUEST_UI_STG_URL}/${transactionId}`;
  }
};

export const getCreditUsageUiUrlViaIdentity = ({
  transactionAccountId,
  email,
}: {
  transactionAccountId: string;
  email: string;
}) => {
  let creditManagementSystemUrl = CREDIT_REQUEST_UI_STG_URL; // default to stg
  if (getMicrosEnv() === 'prod-east') {
    creditManagementSystemUrl = CREDIT_REQUEST_UI_URL;
  }

  const queryParams = [
    `login_hint=${encodeURIComponent(email)}`,
    `prompt=none`,
    `continue=${encodeURIComponent(`${creditManagementSystemUrl}/${transactionAccountId}`)}`,
  ];
  return `${getIdentityUrl()}/login?${queryParams.join('&')}`;
};

export const getGSACSupportUrl = (supportTicketNumber: string) => {
  switch (getMicrosEnv()) {
    case 'prod-east':
      return `${GSAC_BASE_URL}/browse/${supportTicketNumber}`;
    default:
      return `${GSAC_BASE_STG_URL}/browse/${supportTicketNumber}`;
  }
};
